import { useEffect, useState } from "react";
import axiosInstance from "../../../axios-instance";

const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const formatAmount = (amount) => {
  const n = Number(amount);
  if (!Number.isFinite(n) || n <= 0) return "$0.00";
  return `$${n.toFixed(2)}`;
};

const PurchaseHistory = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [payments, setPayments] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || loaded) return;

    let cancelled = false;
    setLoading(true);
    setError("");

    axiosInstance
      .get("/admin/subscription/payment-history", { timeout: 25000 })
      .then((res) => {
        if (cancelled) return;
        if (res.data?.success) {
          setPayments(Array.isArray(res.data.payments) ? res.data.payments : []);
          setLoaded(true);
        } else {
          setError(res.data?.message || "Could not load purchase history.");
        }
      })
      .catch((err) => {
        if (cancelled) return;
        setError(
          err?.response?.data?.message || "Could not load purchase history."
        );
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [open, loaded]);

  return (
    <div className="purchase-history">
      <button
        type="button"
        className={`purchase-history__toggle${open ? " is-open" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        <span>Purchase history</span>
        <span className="purchase-history__chevron" aria-hidden="true" />
      </button>

      {open && (
        <div className="purchase-history__panel">
          {loading ? (
            <p className="purchase-history__empty">Loading payments…</p>
          ) : error ? (
            <p className="purchase-history__empty">{error}</p>
          ) : payments.length === 0 ? (
            <p className="purchase-history__empty">No payments yet.</p>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Reference</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((payment) => (
                    <tr key={payment.id}>
                      <td>{formatDate(payment.date)}</td>
                      <td>{payment.description || payment.plan_name || "Payment"}</td>
                      <td>{formatAmount(payment.amount)}</td>
                      <td>
                        <span className="status active">Paid</span>
                      </td>
                      <td className="purchase-history__ref">
                        {payment.reference || "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PurchaseHistory;
